<template>
  <div v-if="data" class="modal__body">
    <section class="card radial">
      <radial-chart :value="data.progress.percent?.toFixed(2)" label="Gestion total" percent />

      <span class="progress">{{ strategyProgress }}</span>
    </section>

    <section class="card card--stat">
      <div class="card__icon">
        <img :src="phoneDialingImage" alt="dialing" />
      </div>
      <div class="card__value">{{ data.calls_statistics.dialing }}</div>
      <span>Marcando</span>
    </section>

    <section class="card card--stat">
      <div class="card__icon">
        <img :src="phoneCheckImage" alt="check" />
      </div>
      <div class="card__value">{{ data.calls_statistics.answered }}</div>
      <span>Contestada</span>
    </section>

    <section class="card card--stat">
      <div class="card__icon">
        <img :src="phoneNoneImage" alt="none" />
      </div>
      <div class="card__value">{{ data.calls_statistics.no_contact }}</div>
      <span>No contactado</span>
    </section>

    <section class="card card--stat">
      <div class="card__icon">
        <PhoneOutlined class="card__icon--red" :rotate="225" />
      </div>
      <div class="card__value">{{ data.calls_statistics.abandoned }}</div>
      <span>Abandonadas</span>
    </section>

    <section class="card card__accordion">
      <dashboard-call-monitoring :data="data.queues" />
    </section>

    <section class="card">
      <span class="card__title">
        Estado de usuarios

        <a-tooltip title="Número de usuarios que se encuentran en cada estado.">
          <InfoCircleOutlined />
        </a-tooltip>
      </span>

      <CustomScrollbar height="calc(100% - 20px)">
        <agents-status-chart :data="data.agents_statistics" />
      </CustomScrollbar>
    </section>

    <section class="card">
      <span class="card__title"> Resultado de gestiones </span>
      <CustomScrollbar height="calc(100% - 20px)">
        <management-result-chart :stats="data.management_statistics" />
      </CustomScrollbar>
    </section>

    <section class="card">
      <div class="card__title">Monitoreo de usuarios ({{ data?.total_agents }})</div>
      <dashboard-agents :agents="data.agents" />
    </section>
  </div>
</template>

<script>
import { inject } from "vue";

import RadialChart from "@/app/strategies/components/charts/RadialChart.vue";
import ManagementResultChart from "@/app/strategies/components/charts/ManagementResultChart.vue";
import AgentsStatusChart from "@/app/strategies/components/charts/AgentsStatusChart.vue";
import DashboardAgents from "@/app/strategies/components/tables/DashboardAgents.vue";
import DashboardCallMonitoring from "@/app/strategies/components/tables/DashboardCallMonitoring.vue";
import { PhoneOutlined, InfoCircleOutlined } from "@ant-design/icons-vue";

import CustomScrollbar from "@/app/shared/components/organisms/CustomScrollbar.vue";

import phoneDialingImage from "@/app/strategies/assets/phone_dialing.svg?url";
import phoneCheckImage from "@/app/strategies/assets/phone_check.svg?url";
import phoneNoneImage from "@/app/strategies/assets/phone_none.svg?url";

export default {
  components: {
    RadialChart,
    ManagementResultChart,
    AgentsStatusChart,
    DashboardAgents,
    DashboardCallMonitoring,
    PhoneOutlined,
    CustomScrollbar,
    InfoCircleOutlined,
  },
  props: {
    data: {
      required: false,
      type: Object,
      default: null,
    },
  },
  setup() {
    const strategyProgress = inject("strategyProgress");

    return { strategyProgress, phoneDialingImage, phoneCheckImage, phoneNoneImage };
  },
};
</script>

<style lang="sass" scoped>
.modal
  &__body
    color: $gray-9
    height: 600px
    display: grid
    grid-template-columns: repeat(9, 1fr)
    grid-template-rows: repeat(6, 1fr)
    gap: 12px

  &__picker
    margin-bottom: 12px

  &__paragraph
    margin: 16px 0

.radial
  display: grid
  place-content: center

  .progress
    text-align: center

.card
  border: $border-normal
  border-radius: 2px
  padding: 5px 10px

  &__title
    font-weight: 600
    margin-bottom: 12px

  &__icon
    font-size: 32px
    margin: 4px 0

    & img
      display: block
      margin: 6px 0
      height: 36px

    &--red
      color: $red-6

  &__value
    font-size: 30px
    line-height: 38px
    margin-bottom: -4px

  &__accordion
    padding: 0

  &--stat
    display: flex
    flex-direction: column
    align-items: center
    padding-top: 20px

  &:nth-child(1)
    grid-column: 1 / 3
    grid-row: 1 / 3

  &:nth-child(2)
    grid-column: 1 / 1
    grid-row: 3 / 5

  &:nth-child(3)
    grid-column: 2 / 2
    grid-row: 3 / 5

  &:nth-child(4)
    grid-column: 1
    grid-row: 5 / 7

  &:nth-child(5)
    grid-column: 2
    grid-row: 5 / 7

  &:nth-child(6)
    grid-column: 3 / 5
    grid-row: 1 / 7

  &:nth-child(7)
    grid-column: 5 / 7
    grid-row: 1 / 4

  &:nth-child(8)
    grid-column: 5 / 7
    grid-row: 4 / 7

  &:nth-child(9)
    grid-column: 7 / 10
    grid-row: 1 / 7
</style>
